var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOhJazzBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 328.3 418.2",
    style: {
      enableBackground: "new 0 0 328.3 418.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,329h30.1v58.5c0,1.9,0.6,3,2.8,3h11.3c2.1,0,2.8-1.3,2.8-3.2v-95H13.4l5.3-28.8h59.3V396c0,12.2-7.5,22.2-20.9,22.2H20.5 C8.3,418.2,0,410.5,0,398.3V329z M119.1,399l-2.8,19.2H85.1l28-154.7h33.1l27.9,154.7H143l-2.8-19.2H119.1z M122.5,374.5h14.3 l-7-54.8L122.5,374.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M212.5,389.4h29l-5.3,28.8h-65.3l34.8-125.9h-32.2l5.3-28.8h67L212.5,389.4z M290.9,389.4h29l-5.3,28.8h-65.3L284,292.3 h-32.2l5.3-28.8h67L290.9,389.4z M280,198.3h42V243h-42V198.3z M266,245.2V0h-49v95.2h-31.3V0h-49v245.2h50.1v-93h29v93H266z  M127.4,29.9C127.4,11.2,115.9,0,96.6,0H32C12.7,0,1.1,11.2,1.1,29.9v181.6c0,20.4,11.8,32.1,32.3,32.1h61.7 c20.5,0,32.3-11.7,32.3-32.1V29.9z M77.6,198.6H50.7V44.9h27L77.6,198.6z M274.5,0l5.5,190.5h42.3L328.3,0H274.5L274.5,0z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOhJazzBlack);
export default __webpack_public_path__ + "static/media/Oh_jazz_black.01d5828c0af93fda71edfc5f76155416.svg";
export { ForwardRef as ReactComponent };